import { ErrorModal, HelmetDexteel } from "@dexteel/mesf-core";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { get } from "lodash-es";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { TableOperator } from "./components/TableOperator";
import { useCatalogOperatorContext } from "./context/CatalogOperatorContext";
import { getCatalogOperators } from "./repositories/CatalogOperatorRepository";

type Props = {};
export const CatalogOperatorsPage = (props: Props) => {
  const { actions } = useCatalogOperatorContext();
  const { operatorId } = useParams();

  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const getCatalogOperatorsFromAPI = async () => {
    setIsLoading(true);
    const resp = await getCatalogOperators();
    if (resp.ok) {
      const operators = get(resp, "data.tables[0].rows", []);
      actions.setOperators(operators);
      setIsLoading(false);
    } else {
      setError(resp.message);
    }
  };

  useEffect(() => {
    getCatalogOperatorsFromAPI();
  }, []);

  return (
    <>
      <HelmetDexteel title={"Operators"} />
      <Grid container justifyContent="center" alignItems="center">
        <Grid item md={12} xs={12} style={{ margin: 0 }}>
          <Paper
            elevation={1}
            style={{
              width: "100%",
              padding: "10px 0 20px",
              borderRadius: "0.75rem",
              height: "auto",
            }}
          >
            <TableOperator
              operatorId={operatorId}
              isLoading={isLoading}
              getCatalogOperatorsFromAPI={getCatalogOperatorsFromAPI}
            />
          </Paper>
        </Grid>
      </Grid>
      <ErrorModal error={error} onHide={() => setError("")} />
    </>
  );
};
